














import { Component, Vue, Prop } from "vue-property-decorator";
import MultOfferItem from "./MultOfferItem.vue";
import { Offer } from "@/services/offer/offer_handle";
@Component({
  components: { MultOfferItem }
})
export default class MultOffer extends Vue {
  @Prop({ default: "" })
  private likeClass!: string;
  @Prop({ default: "" })
  private iconName!: string;
  @Prop({ default: "" })
  private offerList!: any[];
  @Prop({ default: "" })
  private text!: string;

  private buyOffer(offer: Offer) {
    this.$emit("buyOffer", offer);
  }
}
